const segmentationRoutesMeta = {
  routeName: window.$_t("Segmentation"),
  noPadding: true,
  skipGlobalLoader: true,
  requiredRoles: [],
};

export const segmentationRoutes = [
  {
    path: "/app/segmentation",
    component: () => import("../../vue-app/pages/PageSegmentation.vue"),
    redirect: "/app/segmentation/engagement",
    children: [
      {
        path: "engagement",
        component: () => import("vue-app/components/Segmentation/Engagement/SegmentationEngaged.vue"),
        meta: segmentationRoutesMeta,
      },
      {
        path: "segments",
        component: () => import("vue-app/components/Segmentation/Segments/SegmentationSegments.vue"),
        meta: segmentationRoutesMeta,
        isDev: true,
      },
    ],
  },
];
